import { IconButton } from "@mui/material";
import { ISwiperArrowBtn } from "../../../../interfaces/globalComponents/sliders/material/ISwiperArrowBtn";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

export const SwiperArrowBtn = ({
  Icon,
  action,
  disabled,
  className,
}: ISwiperArrowBtn) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <IconButton
      disabled={disabled}
      onClick={() => action()}
      className={`rounded-full p-[7px] ${className}`}
      sx={{
        backgroundColor: componentColors.secondary.secondaryContainer,
        color: componentColors.secondary.onSecondaryContainer,
        "&:hover": {
          backgroundColor: componentColors.secondary.secondaryContainer,
          color: componentColors.secondary.onSecondaryContainer,
        },
      }}
    >
      <Icon />
    </IconButton>
  );
};
